import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    textAlign: 'left',
    margin: theme.spacing(4, 0, 0, 0),
  },
}))
